import CryptoJS from "crypto-js";

export const Per_Page_Dropdown = async (data) => {
  const a = [];
  for (let i = 5; i <= data; i *= 2) {
    a.push(i);
  }
  a.push(data);
  // console.log(a);

  return a;
};

export const RequiredIs = {
  roles: [1],
  service_term: [1, 2, 3, 4],
  service_type: [1, 2, 3],
  product_type: [1, 2, 3, 4],
};

export const Select2Data = async (data, name, other = false) => {
  const result = data?.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const SelectDelivery = async (data, first_name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: first_name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: first_name });
  }
  return result;
};
export const SelectReportAnalysisData = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: data?.days,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: data?.days });
  }
  return result;
};

export const SelectUsers = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.first_name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const getDimension = async (file) => {
  let reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      var image = new Image();
      image.src = reader.result;
      image.onload = function () {
        resolve({ width: this.width, height: this.height });
      };
    };
    reader.readAsDataURL(file);
  });
};

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
}

export function timeShow(date) {
  if (date) {
    const istDateTime = new Date(date); // Creating a date object
    const istTime = istDateTime.toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata", // Ensure the time is converted to IST
      hour12: true, // Enable 12-hour format with AM/PM
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit", // Include seconds
    });

    return istTime;
  }
}

export const IDS = {
  Role: { List: 1, Add: 2, Edit: 3, Delete: 4 },
  User: { List: 5, Add: 6, Edit: 7, Delete: 8 },
  Country: { List: 9, Add: 10, Edit: 11, Delete: 12 },
  State: { List: 13, Add: 14, Edit: 15, Delete: 16 },
  City: { List: 17, Add: 18, Edit: 19, Delete: 20 },
  Pincode: { List: 21, Add: 22, Edit: 23, Delete: 24 },
  CountryCode: { List: 25, Add: 26, Edit: 27, Delete: 28 },
  Category: { List: 29, Add: 30, Edit: 31, Delete: 32 },
  SubCategory: { List: 33, Add: 34, Edit: 35, Delete: 36 },
  ChildSubCategory: { List: 37, Add: 38, Edit: 39, Delete: 40 },
  FAQCategory: { List: 41, Add: 42, Edit: 43, Delete: 44 },
  FAQ: { List: 45, Add: 46, Edit: 47, Delete: 48 },
  Brands: { List: 49, Add: 50, Edit: 51, Delete: 52 },
  TaxType: { List: 53, Add: 54, Edit: 55, Delete: 56 },
  TaxPercentage: { List: 57, Add: 58, Edit: 59, Delete: 60 },
  CouponCode: { List: 61, Add: 62, Edit: 63, Delete: 64 },
  Blogs: { List: 65, Add: 66, Edit: 67, Delete: 68 },
  Banner: { List: 69, Add: 70, Edit: 71, Delete: 72 },
  WebHeader: { List: 73, Add: 74, Edit: 75, Delete: 76 },
  AppSetup: { List: 220, Add: 221, Edit: 222, Delete: 223 },
  Product: { List: 87, Add: 88, Edit: 89, Delete: 90 },
  WhyChooseUs: { List: 91, Add: 92, Edit: 93, Delete: 94 },
  HappyCustomer: { List: 95, Add: 96, Edit: 97, Delete: 98 },
  OurStory: { List: 99, Add: 100, Edit: 101, Delete: 102 },
  AboutBanner: { List: 103, Add: 104, Edit: 105, Delete: 106 },
  Order: { List: 107, Add: 108, Edit: 109, Delete: 110 },
  Variant_Category: { List: 236, Add: 237, Edit: 238, Delete: 239 },
  Variant: { List: 241, Add: 242, Edit: 243, Delete: 244 },
  SaleBanner: { List: 246, Add: 247, Edit: 248, Delete: 249 },
  OfferProduct: { List: 250, Add: 251, Edit: 252, Delete: 253 },
  SellerBrands: { List: 254, Add: 255, Edit: 256, Delete: 257 },

  PrivacyPolicy: { List: 212, Add: 213, Edit: 214, Delete: 215 },
  Terms: { List: 216, Add: 217, Edit: 218, Delete: 219 },
  Aboutus: { List: 271, Add: 272, Edit: 273, Delete: 274 },

  broadcast_notification: { List: 231, Add: 232, Edit: 233, Delete: 234 },

  CancelationReason: { List: 258, Add: 259, Edit: 260, Delete: 261 },
  ReturnReason: { List: 262, Add: 263, Edit: 264, Delete: 265 },
  CartProduct: { List: 266, Add: 267, Edit: 268, Delete: 269 },
  ReturnedOrder: { List: 111, Edit: 112 },
  OrderToRefund: { List: 113 },

  BulkUpload: {
    Country: 200,
    State: 201,
    City: 203,
    Pincode: 204,
    CountryCode: 205,
    Category: 206,
    SubCategory: 207,
    ChildSubCategory: 208,
    Brands: 210,
    TaxType: 211,
    TaxPercentage: 212,
    Variant_Category: 235,
    Variant: 240,
    Salebanner: 245,
  },
  walletRequest: { List: 228 },
  walletHistory: { List: 229 },
  StockManagement: { List: 230 },
  SearchHistory: { List: 270 },
};

export const return_status = {
  ReturnRequested: 1,
  ReturnApproved: 2,
  ProductPicked: 3,
  Returned: 4,
  ReturnRejected: 5,
  RefundProcess: 6,
  RefundAccept: 7,
  RefundNotAccept: 8,
};

export const order_status = {
  Ordered: 1,
  Processing: 2,
  Shipped: 3,
  Deliverd: 5,
  Cancelled: 4,
  Returned: 6,
};

export function formatDateTime(dateString) {
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const Deliveryboy_stage = {
  Requested: "Requested",
  Rejected: "Rejected",
  Approved: "Approved",
};

const SECRET_KEY = "local-djfhgdkjfghdjkflghdjklf";
export const encodeId = (id) => {
  if (!id) return "";
  const ciphertext = CryptoJS.AES.encrypt(id.toString(), SECRET_KEY).toString();
  return encodeURIComponent(ciphertext); // Make URL-safe
};

export const decodeId = (encodedId) => {
  if (!encodedId) return "";
  try {
    const decoded = decodeURIComponent(encodedId);
    const bytes = CryptoJS.AES.decrypt(decoded, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Invalid ID decryption:", error);
    return "";
  }
};


